import type { CityConfig } from "../city-template/types";

export const burkeVaConfig: CityConfig = {
  city: "Burke",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "burke-va",
  route: "/cities/burke-va",
  title: "Emergency Passport Burke, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Burke, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Burke, Burke Lake, and the Northern Virginia suburban corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Burke, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Burke Lake, Burke Centre, or the Northern Virginia suburban corridor? We help Burke travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Burke%20Virginia%20suburban%20community%20with%20Burke%20Lake%20Park%20and%20the%20scenic%20Burke%20Lake%2C%20family-friendly%20neighborhoods%20with%20mature%20trees%20and%20well-maintained%20homes%2C%20Burke%20Centre%20shopping%20area%20and%20community%20center%2C%20warm%20afternoon%20light%20with%20wooded%20green%20spaces%20and%20Northern%20Virginia%20suburban%20charm%2C%20professional%20photography%20showcasing%20this%20peaceful%20Fairfax%20County%20community%20near%20Springfield%2C%20no%20people%20visible%2C%20scenic%20suburban%20landscape%20with%20lake%20views%20and%20tree-lined%20streets&width=1800&height=700&seq=burke-va-hero-001&orientation=landscape",
  heroImageAlt: "Burke Virginia suburban community with Burke Lake Park and family-friendly neighborhoods",
  geoPosition: "38.7934;-77.2716",
  geoPlacename: "Burke, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 18 miles northeast of Burke via I-395",
  },
  nearbyCitiesZips: [
    { name: "Burke", zips: "22009, 22015, 22032" },
    { name: "Burke Centre", zips: "22015" },
    { name: "Springfield", zips: "22150, 22151, 22152, 22153, 22156, 22158, 22159, 22160, 22161" },
    { name: "Fairfax Station", zips: "22032, 22039" },
    { name: "Clifton", zips: "20124" },
    { name: "Lorton", zips: "22079, 22199" },
    { name: "Alexandria", zips: "22301, 22302, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22314, 22315" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22034, 22035, 22036, 22037, 22038, 22039" },
    { name: "Annandale", zips: "22003" },
    { name: "Falls Church", zips: "22041, 22042, 22043, 22044, 22046" },
    { name: "Tysons", zips: "22102, 22182" },
    { name: "McLean", zips: "22101, 22102, 22106" },
    { name: "Vienna", zips: "22180, 22181, 22182, 22183, 22185" },
    { name: "Woodbridge", zips: "22191, 22192, 22193, 22194, 22195" },
    { name: "Manassas", zips: "20108, 20109, 20110, 20111, 20112, 20113" },
    { name: "Centreville", zips: "20120, 20121, 20122" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Burke and the Northern Virginia suburban corridor" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Fairfax County Suburban Hub", desc: "Serving Burke, Burke Lake, Burke Centre, Fairfax Station, and Clifton" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Springfield VA passport services", route: "/cities/springfield-va" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
    { name: "Alexandria VA passport services", route: "/cities/alexandria-va" },
    { name: "Falls Church VA passport services", route: "/cities/falls-church-va" },
    { name: "Woodbridge VA passport services", route: "/cities/woodbridge-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Burke remotely via secure courier. We do not have a walk-in office in Burke — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Burke and Northern Virginia suburban corridor travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Burke and the Northern Virginia suburban corridor including Burke Centre, Burke Lake, Fairfax Station, Clifton, Springfield, and Lorton",
  serviceAreaIntro: "From the peaceful shores of Burke Lake to the bustling Burke Centre shopping district, from the quiet tree-lined streets of Fairfax Station to the growing communities near Clifton, from the family-friendly neighborhoods of Kings Park to the wooded areas bordering Pohick Creek, from the Springfield border to the Fairfax County heartland — Fast Passport Center serves every corner of Burke and the Northern Virginia suburban corridor. We regularly help travelers from Springfield, Fairfax, Lorton, and Alexandria get their passports fast.",
  nearbyCitiesIntro: "We serve all Burke neighborhoods and the Northern Virginia suburban corridor including Burke Centre, Burke Lake, Fairfax Station, Clifton, Springfield, and Lorton.",
  howItWorksIntro: "Most Burke travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Burke travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Burke and Northern Virginia suburban corridor travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Burke? Here are the most common ones we hear from Northern Virginia suburban corridor travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Virginia Dept of Health Vital Records", href: "https://www.vdh.virginia.gov/vital-records/", description: "Official Virginia vital records office in Richmond" },
    { label: "Marriage Licenses — Fairfax County Circuit Court Clerk", href: "https://www.fairfaxcounty.gov/circuit", description: "Fairfax County Circuit Court Clerk — marriage license issuance" },
    { label: "Divorce Records — Fairfax County Circuit Court Clerk", href: "https://www.fairfaxcounty.gov/circuit", description: "Fairfax County Circuit Court Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of VDH for online vital record orders" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Burke international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer H.",
      location: "Burke, VA",
      rating: 5,
      text: "I live near Burke Lake and needed an emergency passport for a family reunion in Ireland with 5 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Burke Centre Parkway and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Michael S.",
      location: "Burke Centre, VA",
      rating: 5,
      text: "As a Burke Centre resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 4 days. The convenience for Fairfax County families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Laura T.",
      location: "Burke, VA",
      rating: 5,
      text: "First passports for my two children before a school trip to Spain. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 5 days. For Burke families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Robert D.",
      location: "Fairfax Station, VA",
      rating: 5,
      text: "Lost my passport 2 days before a business trip to London. I was in absolute panic. Fast Passport Center had a replacement in my hands in 36 hours. They saved my career and my business trip. Fairfax Station professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "burke-va-1",
      name: "Burke Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6001 Burke Commons Road",
      city: "Burke",
      state: "VA",
      zip: "22015",
      phone: "(703) 425-7374",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Burke Centre",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Burke facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "burke-va-2",
      name: "Springfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8401 Old Keene Mill Road",
      city: "Springfield",
      state: "VA",
      zip: "22152",
      phone: "(703) 451-0289",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Springfield, east of Burke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Burke and Springfield area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "burke-va-3",
      name: "Fairfax Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4000 Chain Bridge Road",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 385-7283",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Fairfax, north of Burke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fairfax and northern Burke area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "burke-va-4",
      name: "Alexandria West Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7900 Richmond Highway",
      city: "Alexandria",
      state: "VA",
      zip: "22306",
      phone: "(703) 660-0315",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Alexandria, southeast of Burke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southeastern Burke and Alexandria area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "burke-va-5",
      name: "Annandale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6900 Columbia Pike",
      city: "Annandale",
      state: "VA",
      zip: "22003",
      phone: "(703) 941-5314",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Annandale, northeast of Burke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northeastern Burke and Annandale area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "burke-va-6",
      name: "Fairfax County Clerk",
      type: "County Clerk",
      address: "4110 Chain Bridge Road",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fairfax, near Burke",
      website: "https://www.fairfaxcounty.gov/circuit",
      websiteLabel: "Fairfax County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to DC via I-395", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Who Can Use It", agency: "Life-or-death emergencies only — proof required", fpc: "All travelers — urgent, expedited, or planned" },
    { feature: "Cost vs Resellers", agency: "Government fee only — no courier service", fpc: "30–100% less than FedEx, Staples, and other resellers" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Burke photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Northern Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Burke applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Burke families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Burke travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Burke or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Burke address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Burke before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Burke for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Northern Virginia suburban corridor." },
    { q: "How fast can I renew my passport in Burke?", a: "Fast Passport Center offers fast passport renewal in Burke in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Burke?", a: "The nearest regional passport agency to Burke is the Washington Passport Agency, located approximately 18 miles northeast in downtown Washington, DC. Accessible via I-395. For urgent processing without the commute, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Burke." },
    { q: "Can I get a same-day passport appointment near Burke?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Burke residents." },
    { q: "Can I expedite a child passport in Burke?", a: "Yes. Fast Passport Center expedites child passports in Burke for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Burke and Fairfax County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Burke with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Burke?", a: "With Fast Passport Center's emergency courier service, Burke travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Burke?", a: "Popular options include the Burke Post Office (22015), Springfield Post Office (22152), Fairfax Main Post Office (22030), and Annandale Post Office (22003). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Burke Centre or Fairfax Station?", a: "We serve the entire Burke area including Burke Centre, Burke Lake, Fairfax Station, Clifton, and all neighborhoods along the Fairfax County southern corridor. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Burke?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Burke", address: "9570 Old Keene Mill Rd, Burke, VA 22015", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Burke", address: "9596 Old Keene Mill Rd, Burke, VA 22015", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Springfield", address: "6795 Springfield Mall, Springfield, VA 22150", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Fairfax", address: "10430 Fairfax Blvd, Fairfax, VA 22030", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Annandale", address: "7252 Arlington Blvd, Falls Church, VA 22042", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Alexandria", address: "7530 Richmond Hwy, Alexandria, VA 22306", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Burke",
      address: "6001 Burke Commons Rd, Burke, VA 22015",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Springfield",
      address: "8300 Old Keene Mill Rd, Springfield, VA 22152",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Fairfax",
      address: "10255 Main St, Fairfax, VA 22030",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Fairfax and northern Burke area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 18 miles northeast of Burke",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "The closest major airport to Burke. Domestic and international flights. Accessible via I-395.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: true,
    },
    {
      code: "IAD",
      name: "Washington Dulles International Airport",
      distance: "Approximately 22 miles west of Burke",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for the DC metro area. Accessible via I-495 or Route 7.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "Approximately 55 miles northeast of Burke",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for DC area travelers. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};